<template>
  <div class="wizard-step-compact">
    <div class="wizard-question mb-0">
      <h5 class="wizard-question-heading">What type of document are you creating?</h5>
      <small class="wizard-question-hint mb-1">
        Choose first — this sets the title on the live preview and the auto invoice name.
      </small>
      <b-form-radio-group
        v-model="formData.documentType"
        :options="documentTypeOptions"
        button-variant="outline-primary"
        buttons
        size="sm"
        class="doc-type-radio-group d-flex"
      />
      <small v-if="formData.documentType === 'Proforma Invoice'" class="text-warning d-block mt-50">
        Proforma invoices are not tax invoices — use Tax Invoice when GST credit is required.
      </small>
    </div>

    <div class="wizard-nav-actions d-flex justify-content-between align-items-center w-100 flex-wrap">
      <b-button
        variant="outline-secondary"
        size="sm"
        class="wizard-icon-btn"
        aria-label="Cancel"
        @click="$emit('cancel')"
      >
        <feather-icon icon="XIcon" size="16" />
      </b-button>
      <b-button
        variant="primary"
        size="sm"
        class="wizard-icon-btn"
        aria-label="Next: Client"
        :disabled="!isValid"
        @click="$emit('next')"
      >
        <feather-icon icon="ArrowRightIcon" size="16" />
      </b-button>
      <small v-if="!isValid" class="text-muted d-block mt-1 w-100">Select a document type to continue.</small>
    </div>
  </div>
</template>

<script>
import { BButton, BFormRadioGroup } from 'bootstrap-vue'
import { INVOICE_DOCUMENT_TYPE_OPTIONS } from '@/utils/invoice-document-types'

export default {
  name: 'WizardDocTypeStep',
  components: { BButton, BFormRadioGroup },
  props: {
    formData: { type: Object, required: true },
  },
  data() {
    return {
      documentTypeOptions: INVOICE_DOCUMENT_TYPE_OPTIONS,
    }
  },
  computed: {
    isValid() {
      return !!(this.formData && this.formData.documentType)
    },
  },
}
</script>

<style src="./wizard-step-shared.css"></style>
